// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NonFictional.module.css */
.NonFictional_container__KxhpB {
  padding: 0px;
  background-color: #1A1A1A;
  color: #fff;
  max-width: 95%;
  width: 100%;
  margin: 0 auto;
}

.NonFictional_boxedWrapper__s5UXl {
  max-width: 100%;
  margin: 0 auto;
  background: #1A1A1A;
  padding: 0px;
 
}

/* Header Styling */
.NonFictional_header__9UyfG {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 20px 10px;
  border-bottom: 1px solid #333;
}

.NonFictional_header__9UyfG h2 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  text-align: left;
}

/* Button Styling */
.NonFictional_viewAllButton__rZjue {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 16px;
  margin-left: auto;
}

.NonFictional_viewAllButton__rZjue:hover {
  background-color: #333;
  border-radius: 4px;
}

/* Swiper Container */
.NonFictional_swiper__nV6SP {
  width: 100%;
  padding: 0;
}

/* Individual Book Item */
.NonFictional_bookItem__pb2Ye {
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  width: 100%;
  display: block;
  padding: 5px;
  height: auto;
}

.NonFictional_bookItem__pb2Ye:hover {
  transform: scale(1.05);
}

/* Image Container - New */
.NonFictional_imageContainer__kC5Ig {
  width: 100%;
  height: 0;
  padding-bottom: 150%; /* 2:3 aspect ratio */
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  border: 1px solid #333;
}

/* Image Styling */
.NonFictional_bookImage__buwdo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 7px;
}

/* Loading & Error Text */
.NonFictional_loading__jYSzv, .NonFictional_error__-7a7n {
  text-align: center;
  font-size: 18px;
  padding: 10px;
}

.NonFictional_error__-7a7n {
  color: red;
}

/* RESPONSIVENESS */

/* Tablets & Small Screens */
@media (max-width: 1024px) {
  .NonFictional_container__KxhpB {
    padding: 0px;
  }
  
  .NonFictional_boxedWrapper__s5UXl {
    padding: 0px;
  }
  
  .NonFictional_header__9UyfG h2 {
    font-size: 22px;
  }
}

/* Mobile Screens */
@media (max-width: 768px) {
  .NonFictional_container__KxhpB {
    padding: 0px;
  }
  
  .NonFictional_boxedWrapper__s5UXl {
    padding: 0px;
  }
  
  .NonFictional_header__9UyfG {
    padding: 0;
    margin-bottom: 10px;
  }
  
  .NonFictional_header__9UyfG h2 {
    font-size: 20px;
  }
  
  .NonFictional_viewAllButton__rZjue {
    font-size: 14px;
    padding: 6px 10px;
  }
  
  .NonFictional_swiper__nV6SP {
    padding: 0 10px;
  }
  
  .NonFictional_bookItem__pb2Ye {
    padding: 4px;
  }
}

/* Small Mobile Screens */
@media (max-width: 480px) {
  .NonFictional_container__KxhpB {
    padding: 0px;
  }
  
  .NonFictional_boxedWrapper__s5UXl {
    padding: 0px;
  }
  
  .NonFictional_header__9UyfG {
    padding: 0 5px 6px;
    margin-bottom: 8px;
  }
  
  .NonFictional_header__9UyfG h2 {
    font-size: 18px;
    font-weight: bold;
  }
  
  .NonFictional_viewAllButton__rZjue {
    font-size: 13px;
    padding: 5px 10px;
  }
  
  .NonFictional_swiper__nV6SP {
    padding: 0 5px;
  }
  
  .NonFictional_bookItem__pb2Ye {
    padding: 3px;
  }
  
  /* Ensure we only show 2 items per view on very small screens */
  .NonFictional_swiper__nV6SP .NonFictional_swiper-slide__45Yjk {
    width: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/NonFictional.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;;AAEd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,SAAS;EACT,oBAAoB,EAAE,qBAAqB;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;;AAEnB,4BAA4B;AAC5B;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA,+DAA+D;EAC/D;IACE,UAAU;EACZ;AACF","sourcesContent":["/* NonFictional.module.css */\n.container {\n  padding: 0px;\n  background-color: #1A1A1A;\n  color: #fff;\n  max-width: 95%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.boxedWrapper {\n  max-width: 100%;\n  margin: 0 auto;\n  background: #1A1A1A;\n  padding: 0px;\n \n}\n\n/* Header Styling */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 0 20px 10px;\n  border-bottom: 1px solid #333;\n}\n\n.header h2 {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n  text-align: left;\n}\n\n/* Button Styling */\n.viewAllButton {\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px 16px;\n  margin-left: auto;\n}\n\n.viewAllButton:hover {\n  background-color: #333;\n  border-radius: 4px;\n}\n\n/* Swiper Container */\n.swiper {\n  width: 100%;\n  padding: 0;\n}\n\n/* Individual Book Item */\n.bookItem {\n  transition: transform 0.3s ease-in-out;\n  cursor: pointer;\n  width: 100%;\n  display: block;\n  padding: 5px;\n  height: auto;\n}\n\n.bookItem:hover {\n  transform: scale(1.05);\n}\n\n/* Image Container - New */\n.imageContainer {\n  width: 100%;\n  height: 0;\n  padding-bottom: 150%; /* 2:3 aspect ratio */\n  position: relative;\n  overflow: hidden;\n  border-radius: 5px;\n  border: 1px solid #333;\n}\n\n/* Image Styling */\n.bookImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 7px;\n}\n\n/* Loading & Error Text */\n.loading, .error {\n  text-align: center;\n  font-size: 18px;\n  padding: 10px;\n}\n\n.error {\n  color: red;\n}\n\n/* RESPONSIVENESS */\n\n/* Tablets & Small Screens */\n@media (max-width: 1024px) {\n  .container {\n    padding: 0px;\n  }\n  \n  .boxedWrapper {\n    padding: 0px;\n  }\n  \n  .header h2 {\n    font-size: 22px;\n  }\n}\n\n/* Mobile Screens */\n@media (max-width: 768px) {\n  .container {\n    padding: 0px;\n  }\n  \n  .boxedWrapper {\n    padding: 0px;\n  }\n  \n  .header {\n    padding: 0;\n    margin-bottom: 10px;\n  }\n  \n  .header h2 {\n    font-size: 20px;\n  }\n  \n  .viewAllButton {\n    font-size: 14px;\n    padding: 6px 10px;\n  }\n  \n  .swiper {\n    padding: 0 10px;\n  }\n  \n  .bookItem {\n    padding: 4px;\n  }\n}\n\n/* Small Mobile Screens */\n@media (max-width: 480px) {\n  .container {\n    padding: 0px;\n  }\n  \n  .boxedWrapper {\n    padding: 0px;\n  }\n  \n  .header {\n    padding: 0 5px 6px;\n    margin-bottom: 8px;\n  }\n  \n  .header h2 {\n    font-size: 18px;\n    font-weight: bold;\n  }\n  \n  .viewAllButton {\n    font-size: 13px;\n    padding: 5px 10px;\n  }\n  \n  .swiper {\n    padding: 0 5px;\n  }\n  \n  .bookItem {\n    padding: 3px;\n  }\n  \n  /* Ensure we only show 2 items per view on very small screens */\n  .swiper .swiper-slide {\n    width: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NonFictional_container__KxhpB`,
	"boxedWrapper": `NonFictional_boxedWrapper__s5UXl`,
	"header": `NonFictional_header__9UyfG`,
	"viewAllButton": `NonFictional_viewAllButton__rZjue`,
	"swiper": `NonFictional_swiper__nV6SP`,
	"bookItem": `NonFictional_bookItem__pb2Ye`,
	"imageContainer": `NonFictional_imageContainer__kC5Ig`,
	"bookImage": `NonFictional_bookImage__buwdo`,
	"loading": `NonFictional_loading__jYSzv`,
	"error": `NonFictional_error__-7a7n`,
	"swiper-slide": `NonFictional_swiper-slide__45Yjk`
};
export default ___CSS_LOADER_EXPORT___;
